import { useContext, memo } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { palette } from '@cbhq/cds-web/tokens';
import { Link } from '@cbhq/cds-web/typography';
import { GlobalFooterContext } from '../context/GlobalFooterContext.js';
import { titleMessages } from '../messages.js';
import Flex from '../shared/Flex.js';
import { messages } from '../shared/messages/navigation.js';
import devices from '../shared/styles/devices.js';
import { theme } from '../shared/styles/theme.js';
import { blogUrl, xUkUrl, xUrl, facebookUrl } from '../shared/utils/links.js';
import { jsxs, jsx } from 'react/jsx-runtime';
const SPACER_LABEL = '•';
const X_LABEL = 'X';
const FACEBOOK_LABEL = 'Facebook';
function SocialLinks() {
  const _useContext = useContext(GlobalFooterContext),
    isUserFromCountry = _useContext.isUserFromCountry;
  const _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  const isUKUser = isUserFromCountry('GB');
  return /*#__PURE__*/jsxs(Flex, {
    children: [/*#__PURE__*/jsx(Link, {
      title: formatMessage(titleMessages.blog),
      href: blogUrl,
      openInNewWindow: true,
      children: formatMessage(messages.blog)
    }), /*#__PURE__*/jsx(Spacer, {
      children: SPACER_LABEL
    }), /*#__PURE__*/jsx(Link, {
      title: formatMessage(titleMessages.x),
      href: isUKUser ? xUkUrl : xUrl,
      openInNewWindow: true,
      children: X_LABEL
    }), /*#__PURE__*/jsx(Spacer, {
      children: SPACER_LABEL
    }), /*#__PURE__*/jsx(Link, {
      title: formatMessage(titleMessages.facebook),
      href: facebookUrl,
      openInNewWindow: true,
      children: FACEBOOK_LABEL
    })]
  });
}
const Spacer = styled.span`
  margin: 0px 3px;
  color: ${palette.foregroundMuted};
  font-size: ${theme.fontSize.medium};
  @media (${devices.phone_small}) {
    font-size: ${theme.fontSize.large};
  }
`;
const Social = /*#__PURE__*/memo(SocialLinks);
export { Social as default };
//# sourceMappingURL=Social.js.map
